const styles  = {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: '4px',
      marginRight: '4px',
      marginTop:'4px',
      width: '100%',
    },
    selectField: {
        marginLeft: '4px',
        marginRight: '4px',
        marginTop:'20px',
        width: '100%',
      },
      selectFieldError: {
        borderBottom:'1px solid Red',
        marginLeft: '4px',
        marginRight: '4px',
        marginTop:'20px',
        width: '100%',
      },
    dense: {
      marginTop: 19,
    }
  };
  export default styles